<template>
  <v-btn
    v-bind="[defaultProps, $attrs]"
    v-on="$listeners"
    :class="className"
    class="rounded-xxl"
  >
    <slot>Button</slot>
  </v-btn>
</template>

<script>
export default {
  name: "BaseButton",
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
    },
    bold: {
      type: Boolean,
    },
  },
  computed: {
    defaultProps: function () {
      let defaultProps = {
        outlined: true,
        color: "white",
        elevation: 0,
      };

      switch (this.variant) {
        case "filter": {
          defaultProps = {
            ...defaultProps,
            outlined: false,
            style:
              "color: #fff !important; background-color: var(--v-tertiary-base) !important;",
            "min-width": 120,
          };
          break;
        }
        case "import": {
          defaultProps = {
            ...defaultProps,
            outlined: true,
            style:
              "color:  #393939 !important; background-color: #fff !important; displey: flex; border: 3px solid var(--v-tertiary-base) !important; font-weight: 600 !important;",
            "min-width": 120,
          };
          break;
        }
        case "outlined": {
          defaultProps = {
            ...defaultProps,
            small: true,
            style:
              "color:  #393939 !important; background-color: #fff !important;",
            "min-width": 120,
          };
          break;
        }
        case "small": {
          defaultProps = {
            ...defaultProps,
            small: true,
            outlined: false,
            maxHeight: this.$vuetify.breakpoint.mdAndUp ? 32 : 22,
          };
          break;
        }
        case "x-small": {
          defaultProps = {
            ...defaultProps,
            outlined: false,
            style:
              "color: #fff !important; background-color: #393939 !important;",
            "min-height": 28,
          };
          break;
        }
        case "large": {
          defaultProps = {
            ...defaultProps,
            large: true,
            style:
              "color: #fff !important; background-color: #393939 !important;",
          };
          break;
        }
        case "primary": {
          defaultProps = {
            ...defaultProps,
            outlined: false,
            color: "primary",
            "min-height": 35,
          };
          break;
        }
        case "black": {
          defaultProps = {
            ...defaultProps,
            outlined: false,
            style:
              "color: #fff !important; background-color: #393939 !important;",
            "min-height": 35,
          };
          break;
        }
        case "btn-cart": {
          defaultProps = {
            ...defaultProps,
            style: "padding: 0 !important;",
          };
          break;
        }
        case "disabled": {
          defaultProps = {
            ...defaultProps,
            outlined: false,
            style:
              "color: #fff !important; background-color: #c2c2c2 !important;",
            "min-height": 35,
          };
          break;
        }
        case "text": {
          defaultProps = {
            ...defaultProps,
            rounded: false,
            outlined: false,
            text: true,
            "min-width": "fit-content",
            height: "auto",
            width: "fit-content",
          };
        }
      }

      if (defaultProps.outlined && this.$attrs.color !== "white") {
        defaultProps.ripple = false;
      }

      return defaultProps;
    },
    className: function () {
      let className = "base-button";

      if (this.$attrs.class) {
        className = `${this.$attrs.class} ${className}`;
      }

      if (this.bold) {
        className = `${className} base-button--bold`;
      }

      if (
        this.defaultProps.outlined &&
        this.$attrs.color !== "white" &&
        this.$attrs.color !== "fourth"
      ) {
        className = `${className} base-button--outlined`;
      }

      return className;
    },
  },
};
</script>

<style lang="scss">
@import "~vuetify/src/styles/styles.sass";

.base-button--bold {
  font-weight: map-get($font-weights, "black");
}

.base-button.v-btn--active::before {
  opacity: 0;
}

.base-button--outlined {
  transition: all 0.2s;
}

.base-button--outlined:hover,
.base-button--outlined:active,
.base-button--outlined:focus,
.base-button--outlined:hover > span > span > p > span,
.base-button--outlined:active > span > span > p > span,
.base-button--outlined:focus > span > span > p > span,
.base-button--outlined:hover *,
.base-button--outlined:active *,
.base-button--outlined:focus * {
  color: black !important;
}
</style>
